import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup as MUIRadioGroup, FormControlLabel } from '@mui/material';
import { Orientation } from '../../utils/consts';
import Icons, { IconSizes } from '../Icons';
import * as S from './styled';

const RadioGroup = ({ value: selectedValue, onChange, options, testId, orientation = Orientation.HORIZONTAL }) => (
  <S.RadioGroupContainer $orientation={orientation}>
    <MUIRadioGroup row name="radio-buttons-group" value={selectedValue} onChange={onChange}>
      {options.map(({ value, label, disabled, tooltip }) => (
        <FormControlLabel
          key={value}
          value={value}
          control={
            <Radio
              icon={disabled ? <Icons.UnCheckedDisabledRadio /> : <Icons.UnCheckedRadio />}
              checkedIcon={disabled ? <Icons.CheckedDisabledRadio /> : <Icons.CheckedRadio />}
              size="medium"
              disabled={disabled}
              data-testid={`radioButton-${testId}-${typeof label === 'string' ? label : value}`}
              disableRipple
            />
          }
          label={
            <S.LabelWrapper>
              {label}
              {!!tooltip && <Icons.Info tooltip={tooltip} size={IconSizes.S} />}
            </S.LabelWrapper>
          }
        />
      ))}
    </MUIRadioGroup>
  </S.RadioGroupContainer>
);

RadioGroup.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.any]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node,
      tooltip: PropTypes.node,
      disabled: PropTypes.bool
    })
  ).isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  testId: PropTypes.string
};

export default RadioGroup;
